<template>
    <div class="podcast-container" :class="route">
        <swiper class="swiper" :options="swiperOption">
            <swiper-slide
                v-for="(slide, index) in list" :key="index"
                :style="{ 'background-image': 'url(' + URL + '/' + slide.img + ')' }"
            >
                <span class="view-data">
                    <img class="eye" :src="Eye" alt="Eye">
                    <span class="count">{{ slide.view | view }}</span>
                </span>
                <router-link 
                    v-if="type == 'Podcast'"
                    tag="div"
                    class="inner-slide"
                    :to="{ name: 'PodcastDetails', params: { id: slide.id }}"
                >
                </router-link>
                <div class="inner-slide" @click="fullscreenChange(slide.file)"></div>
            </swiper-slide>
        </swiper>

        <fullscreen :fullscreen.sync="showFS" class="fullscreen">
            <a class="close-btn" @click="() => { this.showFS = false}">
                <i class="far fa-times" aria-hidden="true"></i>
            </a>
            <video 
                id="video" class="video-inner"
                v-if="showFS"
                controls
                controlsList="nodownload"
                autoplay
            >
                <source
                    v-if="File"
                    :src="URL + '/' + File" 
                    type="video/mp4"
                >
                Your browser does not support the video tag.
            </video>
        </fullscreen>
    </div>
</template>

<script>
import Eye from '@/assets/images/resaneh/eye.png';

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import { APP_API_URL } from '@/utils/libs/api-request';

export default {
    name: 'ResanehSwiper',
    props: {
        list: Array,
        type: String
    },
    filters: {
        // will show the date like 'Jun 24th 2020'
        view: (view) => {
            if (view == undefined) return;
            else if(view < 1000) return view;
            else return (view / 1000).toFixed(0) + ' K';
        }
    },
    data() {
        return {
            Eye: Eye,

            URL: APP_API_URL(),
            route: this.$route.name,

            File: undefined,
            showFS: false,

            swiperOption: {
                slidesPerView: 2,
                spaceBetween: 10,
                autoplay: {
                    delay: 5500,
                    disableOnInteraction: false
                },
                centeredSlides: true,
                breakpoints: {
                    576: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1280: {
                        slidesPerView: 4,
                        spaceBetween: 30
                    }
                }
            }
        }
    },
    methods: {
        fullscreenChange(file) {
            this.File = file;
            this.showFS = !this.showFS;
        }
    },
    watch: {
        '$route'() {
            this.route = this.$route.name;
        }
    },
    components: {
        Swiper,
        SwiperSlide
    }
}
</script>

<style scoped>
/* ---------------------------------------- */
/* --------------- GENERAL ---------------- */
/* ---------------------------------------- */
.swiper {
    min-height: 80pt;
}
.swiper .swiper-slide {
    width: 160px !important;
    height: 250px;

    margin-top: 4vh;
    margin-bottom: 13vh;

    border-radius: 15pt;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.swiper .swiper-slide .view-data {
    width: 25pt;
    height: 45pt;
    padding: 3pt 0pt;
    border-radius: 15pt;

    position: absolute;
    top: 5pt;
    right: 10pt;

    display: flex;
    flex-direction: column;
    text-align: center;

    direction: ltr;
    font-family: Arial, Helvetica, sans-serif;
    background-color: #ddd;
}
.swiper .swiper-slide .view-data .eye {
    width: 15pt;
    margin: 0 auto 7pt;
}
.swiper .swiper-slide .view-data .count {
    font-size: .65rem;
}
.swiper .swiper-slide .inner-slide {
    height: 100%;
    width: 100%;

    padding: 0 10pt;

    text-align: center;
    border-radius: 15pt;

    cursor: pointer;
}
.swiper .swiper-slide .inner-slide span {
    margin-top: 45vh;

    color: #fff;
    font-size: 1.4rem;
    font-weight: bold;
    display: inline-block;
}

/* ---------------------------------------- */
/* ------------ SPECIFIC COLORS ----------- */
/* ---------------------------------------- */
.Podcast .swiper {
    background-color: #665100;
}
.Video .swiper {
    background-color: #004152;
}

/* ---------------------------------------- */
/* -------------- RESPONSIVE  ------------- */
/* ---------------------------------------- */
@media (max-width: 576px) {
    .swiper {
        min-height: 60pt;
    }
    .swiper .swiper-slide .inner-slide span {
        font-size: 1rem;
    }
}

/* ---------------------------------------- */
/* -------------- FULL SCREEN ------------- */
/* ---------------------------------------- */
.fullscreen {
    display: flex;
    position: relative;
    color: #fff;
}
.fullscreen .close-btn {
  position: absolute;
  top: 5pt;
  right: 10pt;
  z-index: 1;

  font-size: 2rem;
  cursor: pointer;
}
.fullscreen .video-inner{
    height: 100%;
    width: 100%;
    margin: auto;
    background-color: #000;
}
</style>